// SuccessPopup.jsx - Composant de pop-up de validation
import React, { useState, useEffect } from 'react';
import './SuccessPopup.css';

const SuccessPopup = ({ show, onClose, donationAmount, isMonthly, lang = 'fr' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // Traductions multilingues
  const translations = {
    fr: {
      title: "Merci pour votre générosité !",
      perMonth: "par mois",
      oneTime: "don unique",
      successMessage: "Votre don a été traité avec succès. Vous faites maintenant partie d'une communauté qui soutient l'AAAS dans sa mission de solidarité et d'entraide auprès de ceux qui ont besoin de notre aide.",
      confirmationEmail: "Vous recevrez un e-mail de confirmation de paiement sous peu.",
      gratitude: "Merci de faire la différence !",
      recurringInfo: "Votre don mensuel nous aidera à fournir un soutien constant. Vous pouvez gérer votre don à tout moment en nous contactant à",
      continueBtn: "Continuer"
    },
    en: {
      title: "Thank You for Your Generous Gift!",
      perMonth: "per month",
      oneTime: "one-time donation",
      successMessage: "Your donation has been successfully processed. You're now part of a community that supports AAAS in its mission of solidarity and mutual aid for those who need our help.",
      confirmationEmail: "You will receive a payment confirmation email shortly.",
      gratitude: "Thank you for making a difference!",
      recurringInfo: "Your monthly donation will help us provide consistent support. You can manage your donation anytime by contacting us at",
      continueBtn: "Continue"
    },
    es: {
      title: "¡Gracias por su generosidad!",
      perMonth: "por mes",
      oneTime: "donación única",
      successMessage: "Su donación ha sido procesada con éxito. Ahora forma parte de una comunidad que apoya a AAAS en su misión de solidaridad y ayuda mutua para quienes necesitan nuestra ayuda.",
      confirmationEmail: "Recibirá un correo electrónico de confirmación de pago en breve.",
      gratitude: "¡Gracias por marcar la diferencia!",
      recurringInfo: "Su donación mensual nos ayudará a brindar apoyo constante. Puede administrar su donación en cualquier momento contactándonos en",
      continueBtn: "Continuar"
    }
  };

  const t = translations[lang] || translations.fr;

  useEffect(() => {
    if (show) {
      setTimeout(() => setIsVisible(true), 100);
      
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [show]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      setIsVisible(false);
      onClose();
    }, 300);
  };

  if (!show) return null;

  return (
    <div 
      className={`success-popup-overlay ${isVisible ? 'visible' : ''} ${isClosing ? 'closing' : ''}`}
      onClick={handleClose}
    >
      <div 
        className={`success-popup-container ${isVisible ? 'visible' : ''} ${isClosing ? 'closing' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confetti-container">
          {[...Array(20)].map((_, i) => (
            <div key={i} className={`confetti confetti-${i % 5}`}></div>
          ))}
        </div>

        <div className="success-icon-container">
          <div className="success-icon">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
              <circle cx="30" cy="30" r="28" fill="#10B981" stroke="#ffffff" strokeWidth="4"/>
              <path d="M20 30l8 8 16-16" stroke="#ffffff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        <div className="success-content">
          <h2 className="success-title">{t.title}</h2>
          
          <div className="donation-summary">
            <p className="donation-amount">
              {donationAmount} € {isMonthly ? t.perMonth : t.oneTime}
            </p>
          </div>

          <p className="success-message">
            {t.successMessage.split('AAAS').map((part, index, array) => (
              <React.Fragment key={index}>
                {part}
                {index < array.length - 1 && <strong> AAAS </strong>}
              </React.Fragment>
            ))}
          </p>

          <p className="confirmation-message">
            {t.confirmationEmail}
          </p>

          <div className="gratitude-message">
            <strong>{t.gratitude}</strong>
          </div>

          {isMonthly && (
            <div className="recurring-info">
              <p>
                <small>
                  {t.recurringInfo}{' '}
                  <strong>dons@aaas.fr</strong>
                </small>
              </p>
            </div>
          )}
        </div>

        <button className="success-close-btn" onClick={handleClose}>
          {t.continueBtn}
        </button>

        <button className="success-close-x" onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default SuccessPopup;